import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';

export const MecanicaDeSuelos: React.FC = () => {
  const serviceData = {
    title: 'Mecánica de Suelos',
    description: 'Ofrecemos servicios de ingeniería geotécnica, incluyendo exploración in situ, geofísica, levantamientos geológicos, instrumentación, ensayes de laboratorio y modelado numérico. Nuestro objetivo es proporcionar una descripción precisa de los materiales en los sitios de construcción para apoyar el éxito de los proyectos de nuestros clientes.',
    image: '/services/Ser_Int_Mecanica.jpg',
    sections: [
      {
        title: 'Exploración directa',
        items: [
          'Pozos a Cielo Abierto (PCA)',
          'Sondeos Profundos Mixtos (SM), técnica de SPT y muestreo inalterado',
          'Sondeos en Roca, a través de barriles y brocas diamantadas (NQ, HQ)',
          'Sondeo de Piezocono (CPTu)',
          'Cono dinámico manual (PANDA)',
          'Prueba de Presiómetro Menard (PMT)',
          'Prueba mediante Sonda de Ficómetro (PHI)',
          'Levantamientos Geológicos'
        ]
      },
      {
        title: 'Exploración directa',
        items: [
          'Pozos a Cielo Abierto (PCA)',
          'Sondeos Profundos Mixtos (SM), técnica de SPT y muestreo inalterado',
          'Sondeos en Roca, a través de barriles y brocas diamantadas (NQ, HQ)',
          'Sondeo de Piezocono (CPTu)',
          'Cono dinámico manual (PANDA)',
          'Prueba de Presiómetro Menard (PMT)',
          'Prueba mediante Sonda de Ficómetro (PHI)',
          'Levantamientos Geológicos'
        ]
      },
      {
        title: 'Exploración indirecta, Métodos Geofísicos',
        items: [
          'Prueba de Down Hole',
          'Prueba de Cross Hole',
          'Estudios de Resistividad Eléctrica',
          'Estudios de Tomografía de Refracción Sísmica (TRS)',
          'Estudio de Radar de Penetración (GPR)',
          'Estudio de ondas superficiales (MASw)'
        ]
      },
      {
        title: 'Ensayos de laboratorio para pruebas de suelos y rocas',
        items: [
          'Contenido de Agua',
          'Granulometrías por mallas',
          'Límites de Consistencia',
          'Peso Volumétrico',
          'Densidad de Sólidos',
          'Ensaye Triaxial',
          'Consolidación unidimensional',
          'Pruebas de permeabilidad en suelos y rocas',
          'Resistencia a compresión simple'
        ]
      },
      {
        title: 'Diseño Geotécnico',
        items: [
          'Diseño de cimientos superficiales y profundos',
          'Análisis de capacidad de carga para cimentación',
          'Análisis de asentamientos a corto y largo plazo',
          'Análisis de excavaciones y empujes en estructuras de retención',
          'Modelado numérico a través de software especializado',
          'Diseño de estructuras de pavimento',
          'Análisis de estabilización y diseño de sostenimiento de taludes y laderes'
        ]
      }
    ]
  };

  return <ServiceDetailPage {...serviceData} />;
};
